import React, {Component} from "react"
import PropTypes from "prop-types";
import FormSearchUsers from "../users/FormSearchUsers/FormSearchUsers";

class FormSearchTeams extends Component {
    state = {
        term: ''
    }

    _delaySearch = null

    componentDidUpdate(prevProps, prevState) {
        if (prevState.term !== this.state.term) {
            this._triggerSearch()
        }
    }

    _handleChangeTerm = (e) => {
        const {value} = e.target

        this.setState({term: value})
    }

    _triggerSearch = () => {
        if (this._delaySearch) {
            clearTimeout(this._delaySearch)
        }

        this._delaySearch = setTimeout(() => {
            const {term} = this.state

            this.props.onChangeQuery({term})
        }, 500)
    }

    render() {
        const {term} = this.state

        return (
            <form className="FormSearchTeams">
                <div className="form-group">
                    <input
                        placeholder="Search by email, id:(xxx), plan:(pro)"
                        className="form-control"
                        onChange={this._handleChangeTerm}
                        value={term} type="text"/>
                </div>
            </form>
        )
    }
}

FormSearchUsers.propTypes = {
    onChangeQuery: PropTypes.func.isRequired
}

export default FormSearchTeams


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/teams/FormSearchTeams.js